<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" style="left: 29px; height: 54px" class="menu_btn" @click="goToLogin">
                        <img src="@/assets/home.png" style="width: 100%" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <div class="graph_date_box">
                    <button type="button"><img src="@/assets/user/c_arrow_w_l.png" @click="prevDate" /></button>
                    <VueDatePicker v-model="state.date" :enable-time-picker="false" locale="ko"
                        :max-date="state.nowDate" auto-apply>
                        <template class="dateFormat" #trigger>
                            <p class="no-select">{{ dateFormat(state.date) }}</p>
                        </template>
                    </VueDatePicker>
                    <button type="button" :style="state.isNextBtn ? '' : 'opacity: 0;'">
                        <img src="@/assets/user/c_arrow_w_r.png" @click="nextDate" />
                    </button>
                </div>
                <DataGrid :type="'vas'" :list="list.data" :columns="list.fields" :totalLength="list.length"
                    :isShowPageBtn="false" :perPage="list.size" :current-page="list.currentPage" @onRowClick="goDetail">
                </DataGrid>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose">
    </ModalComponent>
</template>
<script lang="ts" config>
import {
    onMounted,
    reactive,
    DataGrid,
    router,
    dateFormat,
    apiService,
    watch,
    ModalComponent,
    userStore,
} from "@/BaseComponent";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "../../../public/css/style_test.css";
interface vasList {
    idx: number;
    hour: number;
    content: string;
    content2: string;
    content3: string;
    content4: string;
    content5: string;
    content6: string;
    content7: string;
    content8: string;
    content9: string;
    content10: string;
    content11: string;
    date: string;
}
export default {
    components: {
        DataGrid,
        VueDatePicker,
        ModalComponent,
    },
    setup() {
        const user = userStore();
        const state = reactive({
            date: new Date() as Date,
            nowDate: new Date() as Date, //"2024-08-14T23:00:00" 테스트 날자 형식
            fcmToken: "d01ZCfjITVqZMHP39R_8DW:APA91bG0Did3DKla-oHUzhbL9MGCYV6KXS-St-iRZBNelrLvl14qt-AoT-qXSyeHkU1kF4UTE2bFHK5LGQO3AwAOVU684UA50Lzoa1PpUEEiZ1Hgwx31NItn8PfxKq5le5T39HVrdBKM" as string,
            isModalOpen: false as boolean,
            isNextBtn: false as boolean,
            prevAttendance: {} as object
        });
        const modal = reactive({
            confirm: "" as string,
            cancel: "" as string,
            content: "" as string,
            activeCode: 0 as number,
        });
        const list = reactive({
            data: [] as Array<vasList>,
            size: 12 as number,
            length: 1 as number,
            currentPage: 1 as number,
            totlapage: 0 as number,
            selected: [] as any[],
            fields: [
                {
                    key: "title",
                    label: "제목",
                    clickable: true,
                    class: "text-left text-content",
                    render: function (row: any) {
                        let isShowDiv = false as boolean;

                        if (dateFormat(state.date) === dateFormat(state.nowDate)) {
                            if (row.date === dateFormat(state.date)) {
                                const hour = row.hour.toString().padStart(2, '0');
                                if (new Date(`${row.date}T${hour}:00:00`) <= state.nowDate) {
                                    isShowDiv = true;
                                }
                            }
                        } else if (dateFormat(state.date) === dateFormat(new Date(new Date().setDate(state.nowDate.getDate() - 1)))) {
                            if (row.date === dateFormat(new Date(new Date().setDate(state.nowDate.getDate() - 1)))) {
                                isShowDiv = true;
                                if (row.hour > 24) {
                                    isShowDiv = false;
                                    if (new Date(new Date(row.date).setHours(new Date(row.date).getHours() + row.hour - 9)) < state.nowDate) {
                                        isShowDiv = true;
                                        row.hour = row.hour - 24;
                                    }
                                }
                            }
                        } else {
                            isShowDiv = true;
                            if (row.hour > 24) {
                                isShowDiv = false;
                                if (new Date(new Date(row.date).setHours(new Date(row.date).getHours() + row.hour - 9)) < state.nowDate) {
                                    isShowDiv = true;
                                    row.hour = row.hour - 24;
                                }
                            }
                        }
                        if (row.idx === 0 && row.hour !== 2) {
                            return `<a style="
                                            ${row.content !== "" ? `background-color: #F1F1F1;` : ""}
                                            ${!isShowDiv ? `display: none;` : `display: block;`}
                                        "><p>${row.hour}시 스트레스 & 피로도 & 수면 점수 측정</p></a>`;
                        }
                        if (row.hour % 2 === 1) {
                            return `<a style="
                                            ${row.content !== "" ? `background-color: #F1F1F1;` : ""}
                                            ${!isShowDiv ? `display: none;` : `display: block;`}
                                        "><p>하루 감정, 활동량 및 일과 스트레스 입력</p></a>`;
                        }
                        return `<a style="
                                        ${row.content !== "" ? `background-color: #F1F1F1;` : ""}
                                        ${!isShowDiv ? `display: none;` : `display: block;`}
                                    "><p>${row.hour}시 스트레스 & 피로도 측정</p></a>`;
                    },
                },
            ],
        });

        onMounted(() => {
            getFcmToken();
            defaultList();
            state.date = new Date(user.date);
            if (state.fcmToken !== "" || state.fcmToken === undefined || state.fcmToken === null) {
                getPrevAttendance();
            }
        });

        watch(
            () => state.date,
            () => {
                if (dateFormat(state.date) === dateFormat(state.nowDate)) {
                    state.isNextBtn = false;
                } else {
                    state.isNextBtn = true;
                }
                defaultList();
                user.setDate(state.date.getTime());
                if (state.fcmToken !== "" || state.fcmToken === undefined || state.fcmToken === null) {
                    getAttendance();
                }
            },
        );

        const defaultList = () => {
            list.data = [
                {
                    idx: 0, hour: 8, content: "", content2: "", content3: "", content4: "", content5: "", content6: "", content7: "", content8: "",
                    content9: "", content10: "", content11: "", date: dateFormat(state.date),
                },
                {
                    idx: 1, hour: 12, content: "", content2: "", content3: "", content4: "", content5: "", content6: "", content7: "", content8: "",
                    content9: "", content10: "", content11: "", date: dateFormat(state.date),
                },
                {
                    idx: 2, hour: 16, content: "", content2: "", content3: "", content4: "", content5: "", content6: "", content7: "", content8: "",
                    content9: "", content10: "", content11: "", date: dateFormat(state.date),
                },
                {
                    idx: 3, hour: 20, content: "", content2: "", content3: "", content4: "", content5: "", content6: "", content7: "", content8: "",
                    content9: "", content10: "", content11: "", date: dateFormat(state.date),
                },
                {
                    idx: 4, hour: 21, content: "", content2: "", content3: "", content4: "", content5: "", content6: "", content7: "", content8: "",
                    content9: "", content10: "", content11: "", date: dateFormat(state.date),
                }
            ];
        };
        const resetList = () => {
            list.data = [];
        };

        const getFcmToken = () => {
            if (window.Android && window.Android.getFirebaseToken) {
                state.fcmToken = window.Android.getFirebaseToken();
            }
        };

        const getPrevAttendance = async () => {
            if (dateFormat(state.date) === dateFormat(state.nowDate)) {
                const yesterday = new Date(new Date().setDate(state.nowDate.getDate() - 1));
                const res = await apiService.base.attendanceForMobile(dateFormat(yesterday), state.fcmToken);
                if (res.returnCode === 0) {
                    let attendanceTime = [] as Array<number>;
                    for (let i = 0; i < Object.keys(res.data).length - 1; i++) {
                        if (res.data[`time${i + 1}`] !== 0) {
                            attendanceTime.push(res.data[`time${i + 1}`]);
                        }
                    }
                    if (attendanceTime[attendanceTime.length - 1] > 24) {
                        const tempDate = new Date();
                        tempDate.setHours(attendanceTime[attendanceTime.length - 1] - 20);
                        tempDate.setMinutes(0);
                        tempDate.setSeconds(0);

                        if (state.nowDate < new Date(tempDate)) {
                            prevDate();
                        }
                    }
                }
            }
        };

        const getAttendance = async () => {
            const res = await apiService.base.attendanceForMobile(dateFormat(state.date), state.fcmToken);
            if (res.returnCode === 0) {
                resetList();
                let attendanceTime = [] as Array<number>;
                for (let i = 0; i < Object.keys(res.data).length - 1; i++) {
                    if (res.data[`time${i + 1}`] !== 0) {
                        attendanceTime.push(res.data[`time${i + 1}`]);
                    }
                }
                for (let i = 0; i < attendanceTime.length; i++) {
                    list.data.push(
                        {
                            idx: i, hour: attendanceTime[i], content: "", content2: "", content3: "", content4: "", content5: "", content6: "", content7: "", content8: "",
                            content9: "", content10: "", content11: "", date: dateFormat(state.date),
                        }
                    );
                }
            } else {
                defaultList();
            }
            getVasList();
        };

        const getVasList = async () => {
            const res = await apiService.base.getVasSurvey(dateFormat(state.date), state.fcmToken);
            if (res.returnCode === 0) {
                let locateData = list.data;
                res.list.forEach((newdata: any) => {
                    const index = locateData.findIndex((data: any) => data.idx === newdata.hour - 1);
                    if (index !== -1) {
                        locateData[index].content = newdata.content;
                        locateData[index].content2 = newdata.content2;
                        locateData[index].content3 = newdata.content3;
                        locateData[index].content4 = newdata.content4;
                        locateData[index].content5 = newdata.content5;
                        locateData[index].content6 = newdata.content6;
                        locateData[index].content7 = newdata.content7;
                        locateData[index].content8 = newdata.content8;
                        locateData[index].content9 = newdata.content9;
                        locateData[index].content10 = newdata.content10;
                        locateData[index].content11 = newdata.content11;
                        locateData[index].date = newdata.date;
                    }
                });
                list.data = locateData;
            }
        };

        const goDetail = (index: number) => {
            const clickTable = list.data.filter((item: any) => item.idx === index)[0];
            if (clickTable.hour % 2 === 1) {
                router.push({
                    path: `/VAS/dailyStress`,
                    state: {
                        idx: clickTable.idx,
                        hour: clickTable.hour,
                        date: clickTable.date,
                        token: state.fcmToken,
                        content: clickTable.content,
                        content2: clickTable.content2,
                        content3: clickTable.content3,
                        content4: clickTable.content4,
                        content5: clickTable.content5,
                        content6: clickTable.content6,
                        content7: clickTable.content7,
                        content8: clickTable.content8,
                        content9: clickTable.content9,
                        content10: clickTable.content10,
                        content11: clickTable.content11,
                    },
                });
            } else {
                router.push({
                    path: `/VAS/stressPoint`,
                    state: {
                        idx: clickTable.idx,
                        hour: clickTable.hour,
                        date: clickTable.date,
                        token: state.fcmToken,
                        content: clickTable.content,
                        content2: clickTable.content2,
                        content3: clickTable.content3,
                    },
                });
            }
        };

        const prevDate = () => {
            state.date = new Date(state.date.setDate(state.date.getDate() - 1));
            user.setDate(state.date.getTime());
        };

        const nextDate = () => {
            if (state.isNextBtn) {
                state.date = new Date(state.date.setDate(state.date.getDate() + 1));
                user.setDate(state.date.getTime());
            }
        };

        const goToLogin = () => {
            router.back();
        };

        const modalClose = () => {
            state.isModalOpen = false;
            switch (modal.activeCode) {
                case 1:
                    router.back();
                    break;
                default:
                    break;
            }

        };

        return {
            goDetail,
            dateFormat,
            prevDate,
            nextDate,
            list,
            state,
            modal,
            modalClose,
            goToLogin,
        };
    },
};
</script>

<style scoped>
.board_wrap {
    min-height: 0;
}
</style>

<!-- datePiker 스타일 수정 -->
<style>
.dp__main>div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.no-select {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: white;
    text-align: center;
    font-size: 120%;
}

.dp__main {
    width: 50%;
}

.dp__input_wrap input {
    padding-left: 0px;
    padding-right: 0px;
}

.dp__icon {
    display: none;
}
</style>
